import AuthService from "services/authService";

interface AuthLogoutProps {
    redirectToHome?: boolean;
}

export const handleLogout = async ({ redirectToHome = false }: AuthLogoutProps): Promise<void> => {
    try {
        await AuthService.logout();
        if (redirectToHome) {
            window.location.href = '/';
        } else {
            window.location.reload();
        }
    } catch (error) {
        console.error('Error signing out:', error);
        if (redirectToHome) {
            window.location.href = '/';
        } else {
            window.location.reload();
        }
    }
};